import { createSlice } from '@reduxjs/toolkit';
import { fetchDeliveryReceiptThunk } from '../actions/deliverReceiptActions.ts';
import { DeliveryReceipt } from '@shared/interfaces.ts';

export interface DeliveryReceiptInitialState {
  isLoading: boolean;
  error: string | null;
  receipt: DeliveryReceipt | null;
}
const initialState: DeliveryReceiptInitialState = {
  error: null,
  isLoading: false,
  receipt: null,
};

const deliveryReceiptSlice = createSlice({
  name: 'deliveryReceipt',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = Boolean(action.payload);
    },
    resetDeliveryReceipt: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(fetchDeliveryReceiptThunk.pending, state => {
      state.isLoading = true;
      state.receipt = null;
    });
    builder.addCase(fetchDeliveryReceiptThunk.fulfilled, (state, action) => {
      state.receipt = action.payload;
      state.isLoading = false;
    });
    builder.addCase(fetchDeliveryReceiptThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message || null;
      state.receipt = null;
    });
  },
});

export const deliveryReceiptReducer = deliveryReceiptSlice.reducer;
export const { resetDeliveryReceipt } = deliveryReceiptSlice.actions;
